// React / Next
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/cdos')({
  beforeLoad: () => {
    throw redirect({ to: '/landing-pages/$slug', params: { slug: 'cdos' } });
  },
});
